







































import { Getter } from 'vuex-class';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import PageInitialMixin from '@/mixins/PageInitialMixin';
import CONFIG from '@/common/config';
import fetch from '@/common/api/fetch';
import getUrlParam from '@/common/utils/getUrlParam';
// 内容层级
import ContentLayer from '@/layers/ContentLayer.vue';
import InstitutionIntro from '@/components/common/edit/InstitutionIntro.vue';
import BackgroundMusic from '@/components/common/edit/BackgroundMusic.vue';
import ActivityInstPhone from '@/components/common/edit/ActivityInstPhone.vue';
import DataShow from '@/components/common/edit/DataShow.vue';
import NumShow from '@/components/common/edit/NumShow.vue';
import BarrageSwitch from '@/components/common/edit/BarrageSwitch.vue';
import SMSVerfication from '@/components/common/edit/ SMSVerification.vue';
import SignupItem from '@/components/common/edit/SignupItem.vue';
import ActivityName from '@/components/common/edit/ActivityName.vue';
import RuleIntro from '@/components/common/edit/RuleIntro.vue';
import ContactInfo from '@/components/common/edit/ContactInfo.vue';
import ActivitySetting from '@/components/groupType/edit/ActivitySetting.vue';
import ActivityRule from './components/edit/ActivityRule.vue';

import PayEdit from './components/edit/PayEdit.vue';
import TitleTips from './components/edit/TitleTips.vue';
import ActivityDistributeMode from './components/edit/ActivityDistributeMode.vue';
import TitleWarning from '@/components/common/edit/TitleWarning.vue';

import GroupActivitySection from '@/components/groupType/index/GroupActivitySection.vue';

import FooterLayer from '@/layers/FooterLayer.vue';
import EditFooter from '@/components/common/edit/EditFooter.vue';
import UserAgreementModal from './components/edit/UserAgreement.vue';
import UserAgreementContentModal from './components/edit/UserAgreementContentModal.vue';

import MaskLayer from '@/layers/MaskLayer.vue';

@Component({
  components: {
    'content-layer': ContentLayer,
    'title-tips': TitleTips,
    'title-warning': TitleWarning,
    'activity-setting': ActivitySetting,
    'activity-rule': ActivityRule,
    'group-activity-section': GroupActivitySection,
    'institution-intro': InstitutionIntro,
    'background-music': BackgroundMusic,
    'activity-inst-phone': ActivityInstPhone,
    'data-show': DataShow,
    'num-show': NumShow,
    'barrage-switch': BarrageSwitch,
    'signup-item': SignupItem,
    'sms-verfication': SMSVerfication,
    'activity-name': ActivityName,
    'rule-intro': RuleIntro,
    'contact-info': ContactInfo,
    'pay-edit': PayEdit,
    "activity-distribute-mode": ActivityDistributeMode,
    'footer-layer': FooterLayer,
    'edit-footer': EditFooter,
    'user-agreement-modal': UserAgreementModal,
    'user-agreement-content-modal': UserAgreementContentModal,
    'mask-layer': MaskLayer
  }
})
export default class GroupTypeEdit extends Mixins(PageInitialMixin) {
  @Getter('topTips') topTips!: string;

  isCopy: boolean = false;
  showUserAgreementContent: boolean = false;

  created() {
    const isCopy = getUrlParam('state') == 'copy';
    this.isCopy = isCopy;
  }
  mounted() {
    window.addEventListener('touchmove', this.hiddenKeyboard);
  }
  hiddenKeyboard(evt: Event): void {
    (document.activeElement as HTMLElement).blur();
  }
  handleUserAgreementContentModal() {
    this.showUserAgreementContent = !this.showUserAgreementContent;
  }
}
